<template>
	<div class="basket-line" :class="cssClasses">
		<h4 v-if="headingLevel === 4" class="title">{{ title }}</h4>
		<h3 v-else class="title">{{ title }}</h3>

		<action-badge
				v-if="actionLabel"
				:hide="!showActionLabel">
			{{ actionLabel }}
		</action-badge>

		<div class="price price-normal">{{ formattedNormalPrice }}</div>

		<div v-if="formattedDiscountPrice" class="price price-discount" :class="cssDiscountClasses">
			{{ formattedDiscountPrice }}
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {getFormattedTotalPrice} from '@/utils/priceFormatter';
import ActionBadge from '@/components/basket/ActionBadge.vue';

const props = defineProps<{
		title: string,
		price?: number,
		amount?: number,
		actionLabel?: string | null,
		showActionLabel?: boolean,
		highlight?: boolean,
		discountPrice?: number,
		headingLevel?: number,
		compact?: boolean
	}>();

	const cssClasses = computed(() => {
		const classes = [];

		if (props.highlight) {
			classes.push('highlight');
		}
		if (props.compact) {
			classes.push('compact');
		}

		return classes.join(' ');
	});

	const cssDiscountClasses = computed(() => {
		const classes = [];

		if (props.price !== undefined) {
			classes.push('highlight');
		}

		return classes.join(' ');
	});

	const formattedNormalPrice = computed(() => getFormattedTotalPrice(props.price, props.amount));
	const formattedDiscountPrice = computed(() => {
		if (props.discountPrice === undefined || props.discountPrice < 0) {
			return null;
		}
		return getFormattedTotalPrice(props.discountPrice, props.amount);
	});
</script>

<style scoped lang="scss">
	.basket-line {
		display: flex;
		align-content: start;
		justify-content: start;

		& > * {
			display: block;
		}

		padding: 8px var(--padding-right) 8px 0;
		padding: 8px calc(var(--padding-right) - var(--basket-product-group-padding-x)) 8px 0;

		&.compact {
			padding-top: 2px;
			padding-bottom: 2px;
		}
	}

	.highlight {
		color: var(--color-discount);
	}

	.title {
		font: inherit;
		color: inherit;
		margin: 0 auto 0 0;
		padding: 0;
		flex: 0 1 auto;
	}

	.action-badge {
		margin: 0 .5em 0 .5em;
		flex: 0 0 auto;
	}

	.price {
		font: inherit;
		flex: 0 0 auto;
		margin: 0 0 0 .5em;
	}

	.price-discount {
		flex: 0 0 auto;
	}

	.price-normal:not(:last-child) {
		text-decoration: line-through;
	}
</style>
